import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import Collapse from '@material-ui/core/Collapse';
import ChevronRight from '@material-ui/icons/ChevronRight';
import { colors } from '../../../../constants/colors';
import { fontFamily, fontSize } from '../../../../constants/text';
import styled from 'styled-components';
import { getAcceptedInsurances } from '../../../../core/util/location';
import { isRequestedInsuranceMatchingLocation } from '../../../../core/util/insurance';
import { isNarrowFormat } from '../../../../core/util/device/screen';
import { smallerThanOrEqualTo } from '../../../../core/util/styledComponents';

const Root = styled.div`
  color: ${colors.blueMonday};
  font-size: ${fontSize.mediumSmall};
  line-height: 21px;
  font-family: ${fontFamily.book};
  display: flex;
  flex-direction: row;
`;

const Bold = styled.span`
  color: ${colors.squid};
  font-size: ${fontSize.mediumSmall};
  line-height: 21px;
  font-family: ${fontFamily.bold};
`;

const More = styled.span`
  color: ${colors.blueJayWay};
  cursor: pointer;
  font-size: ${fontSize.mediumSmall};
  margin-left: 5px;

  ${smallerThanOrEqualTo.sm`
    font-size: ${fontSize.small};
  `}
`;

const CollapseContent = styled.div`
  display: flex;
  flex-direction: row;
`;

const ExpandedContent = styled.div`
  display: flex;
  flex-direction: row;
  width: 95%;
  white-space: normal;
`;

const InsuranceTypes = styled.span`
  max-width: 90%;
`;

const ChevronDown = styled(ChevronRight)`
  transform: rotate(90deg);
  height: 15px;
  width: 15px;
  position: relative;
  top: 4px;

  path {
    color: ${colors.blueJayWay};
  }
`;

const ChevronUp = styled(ChevronRight)`
  transform: rotate(-90deg);
  height: 15px;
  width: 15px;
  position: relative;
  top: 4px;

  path {
    color: ${colors.blueJayWay};
  }
`;

const MoreLessContainer = styled.span`
  white-space: nowrap;
`;

class AcceptInsuranceTypes extends PureComponent {
  static propTypes = {
    location: PropTypes.object.isRequired,
    className: PropTypes.string,
    requestedInsurance: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    shouldRenderShowMoreCollapse: PropTypes.bool,
    viewport: PropTypes.number,
    handleClickViewMore: PropTypes.func,
    handleClickViewLess: PropTypes.func,
  };

  static defaultProps = {
    viewport: null,
  };

  constructor(props) {
    super(props);
    this.insurances = getAcceptedInsurances(this.props.location);
    this.state = { insuranceSectionCollapsed: true };
  }

  getInsurerTypesDisplay = () => {
    const { requestedInsurance, shouldRenderShowMoreCollapse, location } = this.props;
    const { insuranceSectionCollapsed } = this.state;

    const acceptedInsuranceTypes = getAcceptedInsurances(location).join(', ');

    if (isRequestedInsuranceMatchingLocation(requestedInsurance, location)) {
      return <Bold>Accepts {requestedInsurance.display_name}</Bold>;
    }

    if (
      shouldRenderShowMoreCollapse &&
      acceptedInsuranceTypes.length > this.MAX_COLLAPSED_INSURER_CHARACTERS
    ) {
      const collapsedInsurances = acceptedInsuranceTypes.slice(
        0,
        this.MAX_COLLAPSED_INSURER_CHARACTERS
      );

      return (
        <Fragment>
          <Collapse in={insuranceSectionCollapsed} timeout="auto" onClick={this.handleViewMore}>
            <CollapseContent>
              <InsuranceTypes>
                {`Accepts ${collapsedInsurances}`}
                <MoreLessContainer>
                  ...
                  <More>more</More>
                  <ChevronDown />
                </MoreLessContainer>
              </InsuranceTypes>
            </CollapseContent>
          </Collapse>
          <Collapse in={!insuranceSectionCollapsed} timeout="auto" onClick={this.handleViewLess}>
            <ExpandedContent>
              <InsuranceTypes>
                {`Accepts ${acceptedInsuranceTypes}`}
                <span>
                  <More>less</More>
                  <ChevronUp />
                </span>
              </InsuranceTypes>
            </ExpandedContent>
          </Collapse>
        </Fragment>
      );
    }

    return `Accepts ${acceptedInsuranceTypes}`;
  };

  MAX_COLLAPSED_INSURER_CHARACTERS = isNarrowFormat(this.props.viewport) ? 15 : 40;

  toggleViewAllInsuranceProviders = () => {
    this.setState({
      insuranceSectionCollapsed: !this.state.insuranceSectionCollapsed,
    });
  };

  handleViewLess = e => {
    const { handleClickViewLess } = this.props;
    e.stopPropagation();
    handleClickViewLess();
    this.toggleViewAllInsuranceProviders();
  };

  handleViewMore = e => {
    const { handleClickViewMore } = this.props;
    e.stopPropagation();
    handleClickViewMore();
    this.toggleViewAllInsuranceProviders();
  };

  render() {
    return <Root className={this.props.className}>{this.getInsurerTypesDisplay()}</Root>;
  }
}

export default AcceptInsuranceTypes;
